export const resetPass = (builder) => ({
    resetPass: builder.mutation({
      query: (credentials) => ({
        url: '/forgot_password_update_password',
        method: 'POST',
        body: credentials,
      }),
    }),
  });